<template>
  <div>
    <el-table
      class="customer"
      :data="tableData"
      style="width: 100%"
      ref="customTable"
      border
      @selection-change="tableSelectionChange"
    >
      <!-- 循环表头数据，判断列显示类型 -->
      <template v-for="(col, index) in tableHeader">
        <div :key="index">
          <template v-if="col.show">
            <!-- 多选框 -->
            <el-table-column
              :align="col.align"
              v-if="col.type == 'selection'"
              :label="col.label"
              :type="col.type"
              :width="col.width"
            ></el-table-column>
            <!-- 索引行 -->
            <el-table-column
              :align="col.align"
              v-else-if="col.type == 'index'"
              :label="col.label"
              :type="col.type"
              :width="col.width"
            ></el-table-column>
            <el-table-column
              :align="col.align"
              v-else-if="col.type == 'image' || col.type == 'images'"
              :label="col.label"
              :width="col.width"
              :prop="col.prop"
            >
              <template slot-scope="scope">
                <div class="content-image">
                  <el-image
                    v-if ="col.type== 'images' "
                    style="width: 50px; height: 50px"
                    :src="scope.row[col.prop]"
                  >
                  </el-image>
                  <el-image
                    v-else
                    style="width: 50px; height: 50px"
                    :src="scope.row[col.prop][0]"
                    :preview-src-list="scope.row[col.prop]"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :align="col.align"
              v-else-if="col.type == 'date'"
              :label="col.label"
              :width="col.width"
              :min-prop="col.prop"
            >
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{
                  scope.row[col.prop] == null ? "暂无" : scope.row[col.prop]
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :align="col.align"
              v-else-if="col.type == 'handle'"
              :label="col.label"
              :min-width="col.width"
              :fixed="col.fixed"
            >
              <template slot-scope="scope">
                <slot name="handles" :row="scope.row"></slot>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="col.showOver"
              :align="col.align"
              v-else
              :label="col.label"
              :min-width="col.width"
              :prop="col.prop"
              :formatter="col.formatter ? col.formatter : null"
            >
            </el-table-column>
          </template>
        </div>
      </template>
    </el-table>
    <pagination
      v-show="config.total > 0"
      :total="config.total"
      v-on="$listeners"
      :page.sync="config.searchList.page"
      :limit.sync="config.searchList.pageSize"
      :pageSizes:sync="config.searchList.pageSizes"
    />
  </div>
</template>

<script>
import Pagination from "./pagination.vue";
export default {
  components: { Pagination },
  props: {
    //分页配置
    config: {
      type: Object,
      default: () => {},
    },
    //表格表头
    tableHeader: {
      type: Array,
      default: () => [],
    },
    //表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    //大图预览
    previewList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      multipleSelection: [], //多选暂存变量
    };
  },
  methods: {
    //表格多选，通知父组件接收数据
    tableSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("getcheck", this.multipleSelection);
    },
    //清空多选
    clearCheck() {
      this.$refs.customTable.clearSelection();
    },
  },
};
</script>

<style scoped="scoped">
.customer {
  margin-bottom: 15px;
}
.content-image {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin: 0 auto;
}
.mar-top {
  margin-top: 15px;
}
</style>
